<mat-card>
  <mat-card-header>
    <div class="header--container">
      <h4>Change your password</h4>
      <!-- <button (click)="close()">
        <mat-icon>close</mat-icon>
      </button> -->
    </div>
  </mat-card-header>
  <mat-card-content>
    <span>For security reasons, you must change your password if your account was created for you and the initial login
      password
      was sent to your email.</span>
    <form [formGroup]="form">
      <div class="input--label">
        <span class="label">New Password</span>
        <span class="asteric">*</span>
      </div>
      <mat-form-field appearance="outline">
        <input [type]="showPassword ? 'text' : 'password'" matInput placeholder="Haskel736!!"
          formControlName="password" />
        <button matSuffix (click)="onShowPassword('password')">
          <mat-icon>{{ showPassword ? 'visibility' : 'visibility_off' }}</mat-icon>
        </button>
        <mat-error *ngIf="form.get('password')?.hasError('required')">
          Password is required.
        </mat-error>

        <mat-error *ngIf="form.get('password')?.hasError('minlength')">
          Password must be at least 6 characters.
        </mat-error>

        <mat-error *ngIf="form.get('password')?.hasError('noUpperCase')">
          Password must contain at least one uppercase letter.
        </mat-error>

        <mat-error *ngIf="form.get('password')?.hasError('noLowerCase')">
          Password must contain at least one lowercase letter.
        </mat-error>

        <mat-error *ngIf="form.get('password')?.hasError('noNumber')">
          Password must contain at least one number.
        </mat-error>

        <mat-error *ngIf="form.get('password')?.hasError('noSymbol')">
          Password must contain at least one symbol.
        </mat-error>
      </mat-form-field>
      <div class="input--label">
        <span class="label">Confirm Password</span>
        <span class="asteric">*</span>
      </div>
      <mat-form-field appearance="outline">
        <input [type]="showConfirmPassword ? 'text' : 'password'" matInput placeholder="Haskel736!"
          formControlName="confirmPassword">
        <button matSuffix (click)="onShowPassword('confirm')">
          <mat-icon>{{ showConfirmPassword ? 'visibility' : 'visibility_off' }}</mat-icon>
        </button>
        <mat-error *ngIf="form.get('confirmPassword')?.hasError('required')">Confirm password is required.</mat-error>
        <mat-error *ngIf="form.hasError('passwordsMismatch')">Passwords do not match.</mat-error>
      </mat-form-field>

      <div class="button--group">
        <button [disabled]="isSubmitting||form.invalid" class="active"
          (click)="onSubmit()">{{isSubmitting?'Submitting...':'Update password'}}</button>
        <!-- <button>Cancel</button> -->
      </div>
    </form>
  </mat-card-content>
</mat-card>